import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { WebsitesEditStep } from './WebsiteEditStep';
import LanguagesList from '../../../components/LanguagesList';

const styles = theme => ({
  stepContainer: {
    display: 'flex',
  },
  stepChildren: {
    margin: '10px 0 156px 10px',
    maxWidth: '974px',
    width: '100%',
    [theme.breakpoints.up('md')]: {
      marginTop: '54px'
    },
    [theme.breakpoints.up('lg')]: {
      marginLeft: '64px'
    },
  },
  languagesWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '30vw',
    maxWidth: '370px',
    minWidth: '130px',
    borderRight: '2px solid rgba(178,178,178,0.5)',
    marginLeft: -16
  },
});

export const WebsitesEditStepWrapper = withStyles(styles)(({classes, languages, onLanguagePick, ...props}) => {
  return <div className={classes.stepContainer}>
    <div className={classes.languagesWrapper}>
      <LanguagesList languages={languages} onLanguagePick={onLanguagePick} chosenLanguage={props.chosenLanguage}/>
    </div>
    <div className={classes.stepChildren}>
      <WebsitesEditStep {...props}/>
    </div>
  </div>;

});



